module.exports = __webpack_public_path__ + "img/frontend_base_tele.213186ba.jpg";